export const getPageTitle = (title: string) => `${title} | Paces`;
